import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps {
    buttonText: string;
    align?: Parameters<typeof Text>[0]["align"];
    className?: string;
}

export function LeadButtonTerms(props: IProps) {
    const {buttonText, className, align} = props;
    const termsOfServiceUrl = rpAppLink.termsOfService.base();

    return (
        <Text as="span" variant="info_txt_3" color="var(--colors-gray-800)" align={align} className={className}>
            Kliknięcie „{buttonText}” oznacza zgodę na zawarcie z Property Group sp. z o.o. umowy na świadczenie usług automatycznego dopasowania i zarzadzania
            ofertami nieruchomości w ramach konta mieszkaniowego na warunkach określonych w{" "}
            <Link href={termsOfServiceUrl} target="_blank" textClassName={termsLink}>
                Regulaminie
            </Link>
            .
        </Text>
    );
}

const termsLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps {
    buttonText: string;
    align?: Parameters<typeof Text>[0]["align"];
    className?: string;
}

export function LeadButtonTerms(props: IProps) {
    const {buttonText, className, align} = props;
    const termsOfServiceUrl = rpAppLink.termsOfService.base();

    return (
        <Text as="span" variant="info_txt_3" color="var(--colors-gray-800)" align={align} className={className}>
            Kliknięcie „{buttonText}” oznacza zgodę na zawarcie z Property Group sp. z o.o. umowy na świadczenie usług automatycznego dopasowania i zarzadzania
            ofertami nieruchomości w ramach konta mieszkaniowego na warunkach określonych w{" "}
            <Link href={termsOfServiceUrl} target="_blank" textClassName={termsLink}>
                Regulaminie
            </Link>
            .
        </Text>
    );
}

const termsLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
